import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/Logo";
import { ThemeToggle } from "@/components/theme-toggle";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { useTrackersBootstrap } from "@/hooks/useTrackersBootstrap";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface PublicLayoutProps {
  children: ReactNode;
  /** Reserved for future use (banner is controlled globally by CookieConsentGate). */
  showCookieBanner?: boolean;
  className?: string;
}

export function PublicLayout({
  children,
  className,
}: PublicLayoutProps) {
  useTrackersBootstrap();

  return (
    <div className={cn("min-h-screen bg-background flex flex-col", className)}>
      <header className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-40">
        <div className="container mx-auto px-4 md:px-6 py-4 flex items-center justify-between max-w-4xl">
          <Link to="/" className="flex items-center">
            <Logo size="md" />
          </Link>
          <nav className="hidden md:flex items-center gap-6">
            <Link
              to="/support"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Support
            </Link>
            <Link
              to="/auth"
              className="text-sm font-medium text-primary hover:text-primary/80 transition-colors"
            >
              Sign In
            </Link>
          </nav>
          <div className="flex items-center gap-2">
            <ThemeToggle className="h-8 w-8 shrink-0" />
            <Button variant="ghost" size="sm" asChild className="h-8">
              <Link to="/auth">Login</Link>
            </Button>
            <Button size="sm" asChild className="h-8">
              <Link to="/">Home</Link>
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="container mx-auto px-4 md:px-6 py-8 md:py-12 max-w-4xl">
          {children}
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
